import PropTypes from "prop-types";
import styled from "styled-components";

import { Placeholder } from "components/Placeholder";

const DrawdownPlaceholderContainer = styled.div`
  .custom-placeholder {
    min-height: ${({ height }) => height};
  }
`;

const DrawdownPlaceholder = ({ height }) => {
  return (
    <DrawdownPlaceholderContainer height={height}>
      <Placeholder className="custom-placeholder" />
    </DrawdownPlaceholderContainer>
  );
};

DrawdownPlaceholder.propTypes = {
  height: PropTypes.string,
};

export { DrawdownPlaceholder };
